module.exports = __webpack_public_path__ + "static/img/A138.f37d084f.jpg";